module.exports = __webpack_public_path__ + "img/discover.8ca59ee8.svg";